import React, { useContext } from "react";
import styled, { css } from "styled-components";
import media from "cssMix/index";
import { ContextStore } from "Reducer";
// comp
import Nav from "Components/Nav/index";
import Main from "Components/Main/index";
import GoTop from "Components/GoTop";
import Advertisement from "Components/advertisement/index";
import Favorite from "Components/Favorite";
import Recent from "Components/Recent";
import PayoutRank from "Components/PayoutRank";
import PlayerRank from "Components/PlayerRank";
import { useGetApiData } from "api";
import SyncLoader from "react-spinners/SyncLoader";
import useRootScrollTop from "useHooks/useRootScrollTop";

export default () => {
  useGetApiData();
  const {
    state: { stateReducer },
  } = useContext(ContextStore);
  const mainAreaRoute = stateReducer.get("mainAreaRoute");
  const isLoading = stateReducer.get("isLoading");
  const scrollTop = useRootScrollTop();

  const mainArea = {
    Lobby: <Main homeScrollTop={scrollTop} />,
    Favorite: <Favorite />,
    Recent: <Recent />,
    PayoutRank: <PayoutRank homeScrollTop={scrollTop} />,
    PlayerRank: <PlayerRank homeScrollTop={scrollTop} />,
  };

  return (
    <Home mainAreaRoute={mainAreaRoute}>
      {isLoading && (
        <Loading>
          <img alt="" src={`images/logo.gif`} />
          <SyncLoader loading={isLoading} css={loadingIcon} />
        </Loading>
      )}
      <Nav homeScrollTop={scrollTop} />
      {mainArea[mainAreaRoute]}
      <Advertisement />
      <GoTop />
    </Home>
  );
};

// style
const Home = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  ${media.tablet`
    height:${(props) =>
      props.mainAreaRoute === "PayoutRank" ||
      props.mainAreaRoute === "PlayerRank"
        ? "100%"
        : "auto"};
    min-height:100%;
    flex-direction:column;
    background: url("images/bg_mobile.png"), #12110f;
    background-size: 100%;
    background-repeat: no-repeat;
    ${(props) =>
      (props.mainAreaRoute === "PayoutRank" ||
        props.mainAreaRoute === "PlayerRank") &&
      `overflow:hidden;`}
`}
`;

const Loading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-image: linear-gradient(to bottom, #1e1c6c, #1e1459 48%, #322257);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  & > img {
    width: 140px;
    margin-bottom: 10px;
    ${media.tablet`
    width: 120px;
    
    `}
  }
`;

const loadingIcon = css`
  display: block;
  margin: 10px auto 0;

  div {
    width: 10px;
    height: 10px;
  }
  div:nth-of-type(1) {
    background-color: #fff;
    margin-right: 5px;
  }
  div:nth-of-type(2) {
    background-color: #fff;
    margin-right: 5px;
  }
  div:nth-of-type(3) {
    background-color: #fff;
  }
`;
